{
  "hero": {
    "title": "NAPAICP Help Center",
    "description": "Search for a task, or browse by role to get something done quickly."
  },
  "search": {
    "placeholder": "Search tasks, features, or error messages",
    "submit": "Search",
    "resultsHeading": "Search Results",
    "resultsFor": "Results for \"{{query}}\"",
    "resultCount": "{{count}} results",
    "clearFilters": "Clear filters",
    "filters": {
      "role": "Role",
      "roleAll": "All",
      "type": "Type"
    },
    "type": {
      "how-to": "How-To",
      "troubleshooting": "Troubleshooting",
      "reference": "Reference",
      "tutorial": "Tutorial",
      "explanation": "Explanation",
      "guide": "Guide",
      "howto": "Quick Start"
    },
    "noResults": {
      "heading": "No results for \"{{query}}\"",
      "suggestion1": "Try a shorter keyword",
      "suggestion2": "Search for the on-screen button name",
      "suggestion3": "Search for the full error message",
      "suggestion4": "Browse popular tasks for your role"
    },
    "autocomplete": {
      "groupTasks": "Tasks",
      "groupTroubleshooting": "Troubleshooting",
      "groupGuide": "Role Guide"
    }
  },
  "gettingStarted": {
    "heading": "First time using NAPAICP?",
    "description": "From creating an account to finishing your first task, in just a few minutes."
  },
  "roles": {
    "heading": "What do you want to do?",
    "student": "Participant",
    "judge": "Judge",
    "organizer": "Organizer",
    "admin": "Platform Admin"
  },
  "home": {
    "browseByType": "Or browse by type"
  },
  "tasks": {
    "heading": "Popular tasks",
    "headingForRole": "Popular tasks for {{role}}"
  },
  "troubleshooting": {
    "heading": "Running into a problem?",
    "cta": "View all troubleshooting articles"
  },
  "workflow": {
    "heading": "All tasks",
    "categories": {
      "account": "Account",
      "registration": "Registration",
      "team": "Team",
      "submission": "Submission",
      "judging": "Judging",
      "judge-management": "Judge management",
      "setup": "Competition setup",
      "results": "Advancement & results",
      "platform": "Platform governance",
      "reference": "Reference",
      "operations": "Competition operations",
      "people-management": "People management",
      "events": "Events platform"
    }
  },
  "article": {
    "roleLabel": "Applies to",
    "estimatedMinutes": "Estimated time",
    "estimatedMinutesValue": "About {{count}} min",
    "lastVerified": "Last verified",
    "verified": "Verified",
    "warningHeading": "Warning",
    "prerequisitesHeading": "Before You Start",
    "diagramAltText": "Status transition diagram",
    "stepsHeading": "Steps",
    "afterwardHeading": "What You'll See",
    "nextStepsHeading": "Next Steps",
    "faqHeading": "Frequently Asked Questions",
    "relatedHeading": "Related Articles",
    "guideLinkCta": "See the full rules for this feature",
    "symptomHeading": "Symptom",
    "causesHeading": "Common Causes",
    "diagnosisHeading": "How to Diagnose",
    "resolutionHeading": "Expected Result",
    "stillStuckHeading": "Still Stuck?",
    "doNotProvideHeading": "Do Not Include",
    "figuresHeading": "Screenshots",
    "figuresNote": "Screens show sample data; names, counts and times are for illustration only."
  },
  "nav": {
    "breadcrumbHome": "Home",
    "breadcrumbHelp": "Help Center"
  },
  "feedback": {
    "prompt": "Was this article helpful?",
    "yes": "Yes",
    "no": "No",
    "commentLabel": "Anything to add? (optional)",
    "commentPlaceholder": "Tell us how we could improve this article",
    "submit": "Submit feedback",
    "submitting": "Submitting…",
    "thanks": "Thanks for the feedback!",
    "error": "Something went wrong sending this. Please try again later."
  }
}
